import React from 'react';
import './style.css';

// Helper function to map card string to image path
const getCardImage = (cardCode) => {
    if (!cardCode) return null;

    try {
        if (cardCode.length < 3) {
            return null;
        }

        // Use cloudfront URL or fallback to local assets
        return `https://d3kb8xz339pq18.cloudfront.net/v12/static/backend/images/cards/${cardCode}.png`;
    } catch (e) {
        return null;
    }
};

// Helper function to parse card string and get array of card images
const parseCards = (cardString) => {
    if (!cardString) return [];

    const cards = cardString.split(',').map(card => card.trim());
    return cards.map(card => getCardImage(card)).filter(card => card !== null);
};

const Dum10 = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
    // Parse cards from detailResult
    const cards = detailResult?.card ? parseCards(detailResult.card) : [];

    return (
        <div className="d-block text-center">
            <h6>Dus ka Dum</h6>
            <div className="container-fluid">
                <div>
                    <h6 className="text-right">
                        <b>Round Id : </b>{roundId}
                    </h6>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '8px' }} className=" text-center">
                        {cards.map((card, index) => (
                            card && (
                                <span key={index}>
                                    <img
                                        src={card}
                                        alt={`Card ${index + 1}`}
                                        className="andar-bahar-image"
                                        onError={(e) => {
                                            // Fallback to local assets
                                            const cardName = card.split('/').pop();
                                            const fallbackPath = `/assets/img/card-results/${cardName}`;
                                            if (e.target.src !== fallbackPath) {
                                                e.target.src = fallbackPath;
                                            } else {
                                                e.target.style.display = 'none';
                                            }
                                        }}
                                    />
                                </span>
                            )
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dum10;
